import { z } from 'zod';
import {
    PaymentCardFormat as PaymentCardFormatDto,
    PaymentCardType as PaymentCardTypeDto,
} from '@mews-commander/data-access';

export const enum RecordCardFormField {
    PaymentCardNumber = 'paymentCardNumber',
    PaymentCardExpiration = 'paymentCardExpiration',
    PaymentCardHolderName = 'paymentCardHolderName',
    PaymentCardType = 'paymentCardType',
    PaymentCardFormat = 'paymentCardFormat',
}

export const recordCardFormSchema = z.object({
    [RecordCardFormField.PaymentCardNumber]: z.coerce.string().regex(/^\d{4}$/, 'ValidateValue'),
    [RecordCardFormField.PaymentCardExpiration]: z.string().optional(),
    [RecordCardFormField.PaymentCardHolderName]: z.string().optional(),
    [RecordCardFormField.PaymentCardType]: z.nativeEnum(PaymentCardTypeDto).or(z.string().min(1)),
    [RecordCardFormField.PaymentCardFormat]: z.nativeEnum(PaymentCardFormatDto).default(PaymentCardFormatDto.Physical),
});

export type RecordCardFormValues = z.infer<typeof recordCardFormSchema>;
